export const enhancer = el => {
  el.addEventListener('click', e => {
    if (el.hash === '#menu') {
      document.body.classList.add('js-disable-scrollbar');
    } else {
      document.body.classList.remove('js-disable-scrollbar');
    }
  });
};
